import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40c0ca7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "element-loading-background": "rgba(0, 0, 0, 0.5)"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "合同信息")
], -1))
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"padding":"0px 10px","height":"26px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"80px"} }, "货物清单", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"60px","font-size":"14px","text-align":"right","padding-right":"5px"} }, " 币制 ", -1))
const _hoisted_12 = { style: {"float":"left","width":"60px","line-height":"18px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","font-size":"14px","text-align":"left","padding-right":"5px"} }, " （注意：包装内型号无具体数量的信息，在产品列表中销售数量的相关统计中将被剔除） ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right","margin-top":"-5px"} }, null, -1))
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 尺寸与数量 ", -1))
const _hoisted_26 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_27 = { style: {"clear":"both","height":"25px"} }
const _hoisted_28 = { style: {"width":"100% !important","border-bottom":"0px solid #999","height":"40px","padding":"0px"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 产品型号/数量/货值 ", -1))
const _hoisted_30 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"clear":"both","height":"25px"} }
const _hoisted_34 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_35 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_36 = { style: {"clear":"both","height":"25px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " ID ", -1))
const _hoisted_38 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_39 = { style: {"max-height":"620px","overflow-y":"auto"} }
const _hoisted_40 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.detail.Data != null && _ctx.detail.Data != undefined)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_card, null, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "ruleForm",
              modelValue: _ctx.detail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Code')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.Code)), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'SigningTime')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.SigningTimeString)), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Partner')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: item.Prop,
                      label: _ctx.type == '10' ? '供应商' : '采购商'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.Partner)), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Address')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all"},
                          title: _ctx.detail.Data.Address
                        }, _toDisplayString(_ctx.isString(_ctx.detail.Data.Address)), 9, _hoisted_3)
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Requirement')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all"},
                          title: _ctx.detail.Data.Requirement
                        }, [
                          (_ctx.detail.Data.Requirement!=null && _ctx.detail.Data.Requirement!=undefined && _ctx.detail.Data.Requirement!='')
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                modelValue: _ctx.detail.Data.Requirement,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.Data.Requirement) = $event)),
                                autosize: { minRows: 5, maxRows: 5 },
                                type: "textarea",
                                style: {"border":"0px"},
                                readonly: true,
                                placeholder: "暂无数据"
                              }, null, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, "暂无数据"))
                        ], 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderWarehouseAnnexs')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        (_ctx.detail.Data.OrderWarehouseAnnexs !=null && _ctx.detail.Data.OrderWarehouseAnnexs !=undefined && _ctx.detail.Data.OrderWarehouseAnnexs.length>0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.OrderWarehouseAnnexs, (p, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  style: {"line-height":"24px"},
                                  key: index
                                }, [
                                  _createElementVNode("a", {
                                    style: {"color":"#409eff","text-decoration":"none"},
                                    target: "_blank",
                                    href: p.Url
                                  }, _toDisplayString(p.Name), 9, _hoisted_7)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, " 暂无数据 "))
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.detail.Data.CurrencySystemName), 1)
              ]),
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "ruleFormPackage",
              modelValue: _ctx.detail,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { style: {"margin-top":"-15px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table, {
                                  data: _ctx.detail.Data.Packages,
                                  ref: "detailPackageTable",
                                  stripe: "",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      prop: "Package",
                                      label: " 包装编号",
                                      width: "180px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.Package == null || scope.row.Package == undefined)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                              title: scope.row.Code
                                            }, _toDisplayString(_ctx.isString(scope.row.Code)), 9, _hoisted_15))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                              title: scope.row.Package.Code
                                            }, _toDisplayString(_ctx.isString(scope.row.Package.Code)), 9, _hoisted_16))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "SizeQuantity",
                                      label: " 箱规cm*cm*cm与数量"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          onClick: ($event: any) => (_ctx.onShape(scope.$index)),
                                          style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                          title: scope.row.SizeQuantity
                                        }, _toDisplayString(_ctx.isString(scope.row.SizeQuantity)), 9, _hoisted_17)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "GrossWeight",
                                      label: "单件毛重/KGS",
                                      width: "150px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          title: scope.row.GrossWeight,
                                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                        }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_18)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "Volume",
                                      label: "单件体积/CBM",
                                      width: "150px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          title: scope.row.Volume,
                                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                        }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_19)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "ProductName",
                                      label: "产品名称"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          onClick: ($event: any) => (_ctx.onSpec(scope.$index)),
                                          style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                          title: scope.row.ProductName
                                        }, _toDisplayString(_ctx.isString(scope.row.ProductName)), 9, _hoisted_20)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "Quantity",
                                      label: "包装数量",
                                      width: "150px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          title: scope.row.Quantity,
                                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                        }, _toDisplayString(_ctx.isString(scope.row.Quantity)), 9, _hoisted_21)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "ShipmentId",
                                      label: "Shipment ID",
                                      width: "180px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        (scope.row.Quantity > 0)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              title: scope.row.ShipmentId,
                                              onClick: ($event: any) => (_ctx.onShipment(scope.$index)),
                                              style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                            }, _toDisplayString(_ctx.isString(scope.row.ShipmentId)), 9, _hoisted_22))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              title: scope.row.ShipmentId,
                                              style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                            }, _toDisplayString(_ctx.isString(scope.row.ShipmentId)), 9, _hoisted_23))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "DeliveryQuantity",
                                      label: "已交货数量",
                                      width: "150px"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("div", {
                                          title: scope.row.DeliveryQuantity,
                                          style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                        }, _toDisplayString(_ctx.isString(scope.row.DeliveryQuantity)), 9, _hoisted_24)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.bottomButtons,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bottomButtons) = $event)),
          onHandleClick: _ctx.handleClick
        }, null, 8, ["modelValue", "onHandleClick"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.shapeRuleForm.Data.visible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shapeRuleForm.Data.visible) = $event)),
          "show-close": false,
          top: "10px",
          style: {"width":"80%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "ruleFormShape",
              modelValue: _ctx.shapeRuleForm,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shapeRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Length')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table, {
                          data: _ctx.shapeRuleForm.Data.Items,
                          ref: "packageTable",
                          stripe: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "Length",
                              label: " L/Φ(长度/直径)(cm)"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Length)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Width",
                              label: " W/Φ(宽度/直径)(cm)"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Width)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Height",
                              label: "H(高度)(cm)"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Height)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Volume",
                              label: "体积(CBM)"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Volume)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "GrossWeight",
                              label: "毛重(KGS)"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.GrossWeight)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Quantity",
                              label: "数量"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Quantity)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.shapeBottomButtons,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shapeBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickShape
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.specRuleForm.Data.visible,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.specRuleForm.Data.visible) = $event)),
          "show-close": false,
          top: "10px",
          style: {"width":"80%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "ruleFormSpec",
              modelValue: _ctx.specRuleForm,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.specRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'NameZh')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table, {
                          data: _ctx.specRuleForm.Data.Items,
                          ref: "packageTable",
                          stripe: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "NameZh",
                              label: "产品中文名称"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.NameZh)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "NameEn",
                              label: " 产品英文名称"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.NameEn)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Height",
                              label: "规格型号名称"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Spec.Name)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "SpecImages",
                              label: "图片"
                            }, {
                              default: _withCtx((scope) => [
                                (scope.row.Spec.SpecImages !=null &&scope.row.Spec.SpecImages !=undefined &&scope.row.Spec.SpecImages.length>0)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.onImage(scope.row)),
                                      style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all"}
                                    }, " 查看 ", 8, _hoisted_31))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createVNode(_component_miezz_thumbnail, {
                                        type: 'image',
                                        icon: 'DocumentDelete'
                                      })
                                    ]))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Quantity",
                              label: "数量"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Quantity)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "ChargeUnithEn",
                              label: "单位"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.ChargeUnithEn)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "UnitPrice",
                              label: '单价（' + _ctx.detail.Data.CurrencySystemName + '）'
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.UnitPrice)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "TotalPrice",
                              label: '总价（' + _ctx.detail.Data.CurrencySystemName + '）'
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.isString(scope.row.TotalPrice)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.specBottomButtons,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.specBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickSpec
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.imageRuleForm.visiable,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.imageRuleForm.visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.imageRuleForm.row.Spec.Product.NameZh) + "/" + _toDisplayString(_ctx.imageRuleForm.row.Spec.Name), 1),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_carousel, {
                interval: 5000,
                arrow: "always",
                loop: false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageRuleForm.row.Images, (item) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          style: {"width":"100%","height":"100%"},
                          src: item,
                          fit: _ctx.fit
                        }, null, 8, ["src", "fit"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.imageBottomButtons,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.imageBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImage
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.shipmentRuleForm.visiable,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.shipmentRuleForm.visiable) = $event)),
          top: "10px",
          "show-close": false,
          style: {"width":"680px"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "ruleFormShipment",
              modelValue: _ctx.shipmentRuleForm,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.shipmentRuleForm) = $event)),
              fix: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (p.Type == 10)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "Shipment ID"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isString(p.Value)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (p.Type == 11)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "Reference ID"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isString(p.Value)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (p.Type == 20)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "FBA No."
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(index - 1) + "、" + _toDisplayString(_ctx.isString(p.Value)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.shipmentBottomButtons,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.shipmentBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickShipment
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])), [
        [
          _directive_loading,
          _ctx.isLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    : _createCommentVNode("", true)
}